module.exports = __webpack_public_path__ + "assets/img/Logo_Paycell-S.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Logo_Paycell-S.png
// module id = 121
// module chunks = 0